export default __webpack_public_path__ + "static/media/Trava.31c4d669.png";